export default __webpack_public_path__ + "static/media/star.f180ce31.svg";